import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import Button from "../Shared/Button";
import {
  getPractitionerEmailReviewingConfigs,
  updatePractitionerEmailReviewingConfigs,
} from "../../services/practitioner";
import { selectActivePractitioners } from "../appSlice";

const PractitionerEmailReviewingConfig = () => {
  const practitioners = useSelector(selectActivePractitioners);
  const [configChanged, setConfigChanged] = useState(false);
  const [isUpdatingConfig, setIsUpdatingConfig] = useState(false);
  const [emailReviewingConfigs, setEmailReviewingConfigs] = useState({});
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    setEmailReviewingConfigs(
      practitioners.reduce(
        (acc, practitioner) => ({
          ...acc,
          [practitioner.practitionerId]: false,
        }),
        {}
      )
    );
    getPractitionerEmailReviewingConfigs().then(({ result, error }) =>
      setEmailReviewingConfigs((configs) => ({
        ...configs,
        ...result,
      }))
    );
  }, [practitioners]);

  const handleUpdateEmailReviewingConfig = ({ practitionerId, needsToRecieveEmail }) => {
    if (!_.isNull(notification)) {
      setNotification(null);
    }
    setConfigChanged(true);
    setEmailReviewingConfigs({
      ...emailReviewingConfigs,
      [practitionerId]: needsToRecieveEmail,
    });
  };

  const handleSubmit = async (e) => {
    if (!_.isNull(notification)) {
      setNotification(null);
    }
    setIsUpdatingConfig(true);
    try {
      await updatePractitionerEmailReviewingConfigs(
        Object.entries(emailReviewingConfigs)
          .filter((config) => config[1])
          .reduce(
            (acc, config) => ({
              ...acc,
              [config[0]]: config[1],
            }),
            {}
          )
      );
      setConfigChanged(false);
      setIsUpdatingConfig(false);
      setNotification({
        success: true,
        message: "Update config successfully!",
      });
    } catch {
      setIsUpdatingConfig(false);
      setNotification({
        success: false,
        message: "Update config failed!",
      });
    }
  };

  return (
    <>
      <p className="menu-label">Practitioner Email Config</p>
      <div className="columns is-mobile is-size-7">
        <div className="column is-half">
          {!_.isNull(notification) && (
            <div
              className={`notification is-light is-size-7 is-radiusless ${
                notification.success ? "is-success" : "is-danger"
              }`}
            >
              {notification.message}
            </div>
          )}
          <div className="table-container apt-table">
            <table className="table is-fullwidth is-stripe is-hoverable is-scrollable is-size-7">
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>Need to recieve email</td>
                </tr>
                {practitioners.map((practitioner) => (
                  <tr key={practitioner.practitionerId}>
                    <td>
                      {practitioner.firstName} {practitioner.lastName}
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={emailReviewingConfigs[practitioner.practitionerId] || false}
                        onChange={(e) =>
                          handleUpdateEmailReviewingConfig({
                            practitionerId: practitioner.practitionerId,
                            needsToRecieveEmail: e.target.checked,
                            setConfigChanged,
                          })
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Button text="SUBMIT" onClick={handleSubmit} isLoading={isUpdatingConfig} disabled={!configChanged} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PractitionerEmailReviewingConfig;
